import { jsx as h, jsxs as N, Fragment as fe } from "react/jsx-runtime";
import * as l from "react";
import We, { forwardRef as ut, useState as ke, useRef as st, useImperativeHandle as ct, useEffect as dt } from "react";
import { c as U } from "../../index-DLeNytVF.js";
import { S as ft, u as he, c as pt } from "../../index-nyDQUcyF.js";
import { c as mt, b as vt } from "../../index-DY0e2-rS.js";
import { u as k } from "../../index-CYVF_faS.js";
import { u as gt } from "../../index-BUuv-jtL.js";
import { P as ht, D as bt } from "../../index-Bau437MN.js";
import { R as yt, h as Et, u as St, F as wt } from "../../Combination-DIa2QCCA.js";
import { P as be } from "../../index-BLBC6XLQ.js";
import { P as q } from "../../index--Ec6-Sd5.js";
import "react-dom";
import { c as ae } from "../../cn-gv_k3DnN.js";
import { a as xt, p as le } from "../../parse-phone-number-GKY-lvsa.js";
import { focusRing as Ct } from "../../utils/focus-ring.js";
import { Icon as Pe } from "../icon/icon.js";
import { Popover as Rt, PopoverTrigger as _t, PopoverContent as Dt } from "../popover/popover.js";
import { countries as Me } from "./countries.js";
function Ot(e, r) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = It(e)) || r) {
    t && (e = t);
    var a = 0;
    return function() {
      return a >= e.length ? { done: !0 } : { done: !1, value: e[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function It(e, r) {
  if (e) {
    if (typeof e == "string") return Te(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Te(e, r);
  }
}
function Te(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, a = new Array(r); t < r; t++)
    a[t] = e[t];
  return a;
}
function Nt(e) {
  for (var r = "", t = Ot(e.split("")), a; !(a = t()).done; ) {
    var n = a.value;
    r += At(n, r) || "";
  }
  return r;
}
function At(e, r, t) {
  return e === "+" ? r ? void 0 : "+" : xt(e);
}
var Le = 1, kt = 0.9, Pt = 0.8, Mt = 0.17, ie = 0.1, ue = 0.999, Tt = 0.9999, Lt = 0.99, $t = /[\\\/_+.#"@\[\(\{&]/, Vt = /[\\\/_+.#"@\[\(\{&]/g, Ft = /[\s-]/, Ge = /[\s-]/g;
function pe(e, r, t, a, n, o, u) {
  if (o === r.length) return n === e.length ? Le : Lt;
  var s = `${n},${o}`;
  if (u[s] !== void 0) return u[s];
  for (var p = a.charAt(o), m = t.indexOf(p, n), f = 0, c, b, g, S; m >= 0; ) c = pe(e, r, t, a, m + 1, o + 1, u), c > f && (m === n ? c *= Le : $t.test(e.charAt(m - 1)) ? (c *= Pt, g = e.slice(n, m - 1).match(Vt), g && n > 0 && (c *= Math.pow(ue, g.length))) : Ft.test(e.charAt(m - 1)) ? (c *= kt, S = e.slice(n, m - 1).match(Ge), S && n > 0 && (c *= Math.pow(ue, S.length))) : (c *= Mt, n > 0 && (c *= Math.pow(ue, m - n))), e.charAt(m) !== r.charAt(o) && (c *= Tt)), (c < ie && t.charAt(m - 1) === a.charAt(o + 1) || a.charAt(o + 1) === a.charAt(o) && t.charAt(m - 1) !== a.charAt(o)) && (b = pe(e, r, t, a, m + 1, o + 2, u), b * ie > c && (c = b * ie)), c > f && (f = c), m = t.indexOf(p, m + 1);
  return u[s] = f, f;
}
function $e(e) {
  return e.toLowerCase().replace(Ge, " ");
}
function jt(e, r, t) {
  return e = t && t.length > 0 ? `${e + " " + t.join(" ")}` : e, pe(e, r, $e(e), $e(r), 0, 0, {});
}
var ye = "Dialog", [He, Ur] = mt(ye), [Wt, I] = He(ye), Ke = (e) => {
  const {
    __scopeDialog: r,
    children: t,
    open: a,
    defaultOpen: n,
    onOpenChange: o,
    modal: u = !0
  } = e, s = l.useRef(null), p = l.useRef(null), [m = !1, f] = gt({
    prop: a,
    defaultProp: n,
    onChange: o
  });
  return /* @__PURE__ */ h(
    Wt,
    {
      scope: r,
      triggerRef: s,
      contentRef: p,
      contentId: k(),
      titleId: k(),
      descriptionId: k(),
      open: m,
      onOpenChange: f,
      onOpenToggle: l.useCallback(() => f((c) => !c), [f]),
      modal: u,
      children: t
    }
  );
};
Ke.displayName = ye;
var Ue = "DialogTrigger", Gt = l.forwardRef(
  (e, r) => {
    const { __scopeDialog: t, ...a } = e, n = I(Ue, t), o = he(r, n.triggerRef);
    return /* @__PURE__ */ h(
      q.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": n.open,
        "aria-controls": n.contentId,
        "data-state": we(n.open),
        ...a,
        ref: o,
        onClick: U(e.onClick, n.onOpenToggle)
      }
    );
  }
);
Gt.displayName = Ue;
var Ee = "DialogPortal", [Ht, Be] = He(Ee, {
  forceMount: void 0
}), qe = (e) => {
  const { __scopeDialog: r, forceMount: t, children: a, container: n } = e, o = I(Ee, r);
  return /* @__PURE__ */ h(Ht, { scope: r, forceMount: t, children: l.Children.map(a, (u) => /* @__PURE__ */ h(be, { present: t || o.open, children: /* @__PURE__ */ h(ht, { asChild: !0, container: n, children: u }) })) });
};
qe.displayName = Ee;
var J = "DialogOverlay", ze = l.forwardRef(
  (e, r) => {
    const t = Be(J, e.__scopeDialog), { forceMount: a = t.forceMount, ...n } = e, o = I(J, e.__scopeDialog);
    return o.modal ? /* @__PURE__ */ h(be, { present: a || o.open, children: /* @__PURE__ */ h(Kt, { ...n, ref: r }) }) : null;
  }
);
ze.displayName = J;
var Kt = l.forwardRef(
  (e, r) => {
    const { __scopeDialog: t, ...a } = e, n = I(J, t);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ h(yt, { as: ft, allowPinchZoom: !0, shards: [n.contentRef], children: /* @__PURE__ */ h(
        q.div,
        {
          "data-state": we(n.open),
          ...a,
          ref: r,
          style: { pointerEvents: "auto", ...a.style }
        }
      ) })
    );
  }
), $ = "DialogContent", Ye = l.forwardRef(
  (e, r) => {
    const t = Be($, e.__scopeDialog), { forceMount: a = t.forceMount, ...n } = e, o = I($, e.__scopeDialog);
    return /* @__PURE__ */ h(be, { present: a || o.open, children: o.modal ? /* @__PURE__ */ h(Ut, { ...n, ref: r }) : /* @__PURE__ */ h(Bt, { ...n, ref: r }) });
  }
);
Ye.displayName = $;
var Ut = l.forwardRef(
  (e, r) => {
    const t = I($, e.__scopeDialog), a = l.useRef(null), n = he(r, t.contentRef, a);
    return l.useEffect(() => {
      const o = a.current;
      if (o) return Et(o);
    }, []), /* @__PURE__ */ h(
      Ze,
      {
        ...e,
        ref: n,
        trapFocus: t.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: U(e.onCloseAutoFocus, (o) => {
          var u;
          o.preventDefault(), (u = t.triggerRef.current) == null || u.focus();
        }),
        onPointerDownOutside: U(e.onPointerDownOutside, (o) => {
          const u = o.detail.originalEvent, s = u.button === 0 && u.ctrlKey === !0;
          (u.button === 2 || s) && o.preventDefault();
        }),
        onFocusOutside: U(
          e.onFocusOutside,
          (o) => o.preventDefault()
        )
      }
    );
  }
), Bt = l.forwardRef(
  (e, r) => {
    const t = I($, e.__scopeDialog), a = l.useRef(!1), n = l.useRef(!1);
    return /* @__PURE__ */ h(
      Ze,
      {
        ...e,
        ref: r,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (o) => {
          var u, s;
          (u = e.onCloseAutoFocus) == null || u.call(e, o), o.defaultPrevented || (a.current || (s = t.triggerRef.current) == null || s.focus(), o.preventDefault()), a.current = !1, n.current = !1;
        },
        onInteractOutside: (o) => {
          var p, m;
          (p = e.onInteractOutside) == null || p.call(e, o), o.defaultPrevented || (a.current = !0, o.detail.originalEvent.type === "pointerdown" && (n.current = !0));
          const u = o.target;
          ((m = t.triggerRef.current) == null ? void 0 : m.contains(u)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && n.current && o.preventDefault();
        }
      }
    );
  }
), Ze = l.forwardRef(
  (e, r) => {
    const { __scopeDialog: t, trapFocus: a, onOpenAutoFocus: n, onCloseAutoFocus: o, ...u } = e, s = I($, t), p = l.useRef(null), m = he(r, p);
    return St(), /* @__PURE__ */ N(fe, { children: [
      /* @__PURE__ */ h(
        wt,
        {
          asChild: !0,
          loop: !0,
          trapped: a,
          onMountAutoFocus: n,
          onUnmountAutoFocus: o,
          children: /* @__PURE__ */ h(
            bt,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": we(s.open),
              ...u,
              ref: m,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ N(fe, { children: [
        /* @__PURE__ */ h(Zt, { titleId: s.titleId }),
        /* @__PURE__ */ h(Xt, { contentRef: p, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), Se = "DialogTitle", qt = l.forwardRef(
  (e, r) => {
    const { __scopeDialog: t, ...a } = e, n = I(Se, t);
    return /* @__PURE__ */ h(q.h2, { id: n.titleId, ...a, ref: r });
  }
);
qt.displayName = Se;
var Je = "DialogDescription", zt = l.forwardRef(
  (e, r) => {
    const { __scopeDialog: t, ...a } = e, n = I(Je, t);
    return /* @__PURE__ */ h(q.p, { id: n.descriptionId, ...a, ref: r });
  }
);
zt.displayName = Je;
var Xe = "DialogClose", Yt = l.forwardRef(
  (e, r) => {
    const { __scopeDialog: t, ...a } = e, n = I(Xe, t);
    return /* @__PURE__ */ h(
      q.button,
      {
        type: "button",
        ...a,
        ref: r,
        onClick: U(e.onClick, () => n.onOpenChange(!1))
      }
    );
  }
);
Yt.displayName = Xe;
function we(e) {
  return e ? "open" : "closed";
}
var Qe = "DialogTitleWarning", [Br, et] = vt(Qe, {
  contentName: $,
  titleName: Se,
  docsSlug: "dialog"
}), Zt = ({ titleId: e }) => {
  const r = et(Qe), t = `\`${r.contentName}\` requires a \`${r.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${r.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${r.docsSlug}`;
  return l.useEffect(() => {
    e && (document.getElementById(e) || console.error(t));
  }, [t, e]), null;
}, Jt = "DialogDescriptionWarning", Xt = ({ contentRef: e, descriptionId: r }) => {
  const a = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${et(Jt).contentName}}.`;
  return l.useEffect(() => {
    var o;
    const n = (o = e.current) == null ? void 0 : o.getAttribute("aria-describedby");
    r && n && (document.getElementById(r) || console.warn(a));
  }, [a, e, r]), null;
}, Qt = Ke, er = qe, tr = ze, rr = Ye, tt = l.forwardRef((e, r) => {
  const { children: t, ...a } = e, n = l.Children.toArray(t), o = n.find(or);
  if (o) {
    const u = o.props.children, s = n.map((p) => p === o ? l.Children.count(u) > 1 ? l.Children.only(null) : l.isValidElement(u) ? u.props.children : null : p);
    return /* @__PURE__ */ h(me, { ...a, ref: r, children: l.isValidElement(u) ? l.cloneElement(u, void 0, s) : null });
  }
  return /* @__PURE__ */ h(me, { ...a, ref: r, children: t });
});
tt.displayName = "Slot";
var me = l.forwardRef((e, r) => {
  const { children: t, ...a } = e;
  if (l.isValidElement(t)) {
    const n = lr(t);
    return l.cloneElement(t, {
      ...ar(a, t.props),
      // @ts-ignore
      ref: r ? pt(r, n) : n
    });
  }
  return l.Children.count(t) > 1 ? l.Children.only(null) : null;
});
me.displayName = "SlotClone";
var nr = ({ children: e }) => /* @__PURE__ */ h(fe, { children: e });
function or(e) {
  return l.isValidElement(e) && e.type === nr;
}
function ar(e, r) {
  const t = { ...r };
  for (const a in r) {
    const n = e[a], o = r[a];
    /^on[A-Z]/.test(a) ? n && o ? t[a] = (...s) => {
      o(...s), n(...s);
    } : n && (t[a] = n) : a === "style" ? t[a] = { ...n, ...o } : a === "className" && (t[a] = [n, o].filter(Boolean).join(" "));
  }
  return { ...e, ...t };
}
function lr(e) {
  var a, n;
  let r = (a = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : a.get, t = r && "isReactWarning" in r && r.isReactWarning;
  return t ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, t = r && "isReactWarning" in r && r.isReactWarning, t ? e.props.ref : e.props.ref || e.ref);
}
var ir = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], P = ir.reduce((e, r) => {
  const t = l.forwardRef((a, n) => {
    const { asChild: o, ...u } = a, s = o ? tt : r;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ h(s, { ...u, ref: n });
  });
  return t.displayName = `Primitive.${r}`, { ...e, [r]: t };
}, {}), ve = { exports: {} }, se = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ve;
function ur() {
  if (Ve) return se;
  Ve = 1;
  var e = We;
  function r(c, b) {
    return c === b && (c !== 0 || 1 / c === 1 / b) || c !== c && b !== b;
  }
  var t = typeof Object.is == "function" ? Object.is : r, a = e.useState, n = e.useEffect, o = e.useLayoutEffect, u = e.useDebugValue;
  function s(c, b) {
    var g = b(), S = a({ inst: { value: g, getSnapshot: b } }), x = S[0].inst, y = S[1];
    return o(
      function() {
        x.value = g, x.getSnapshot = b, p(x) && y({ inst: x });
      },
      [c, g, b]
    ), n(
      function() {
        return p(x) && y({ inst: x }), c(function() {
          p(x) && y({ inst: x });
        });
      },
      [c]
    ), u(g), g;
  }
  function p(c) {
    var b = c.getSnapshot;
    c = c.value;
    try {
      var g = b();
      return !t(c, g);
    } catch {
      return !0;
    }
  }
  function m(c, b) {
    return b();
  }
  var f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? m : s;
  return se.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : f, se;
}
var ce = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fe;
function sr() {
  return Fe || (Fe = 1, process.env.NODE_ENV !== "production" && function() {
    function e(g, S) {
      return g === S && (g !== 0 || 1 / g === 1 / S) || g !== g && S !== S;
    }
    function r(g, S) {
      f || n.startTransition === void 0 || (f = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var x = S();
      if (!c) {
        var y = S();
        o(x, y) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), c = !0);
      }
      y = u({
        inst: { value: x, getSnapshot: S }
      });
      var R = y[0].inst, A = y[1];
      return p(
        function() {
          R.value = x, R.getSnapshot = S, t(R) && A({ inst: R });
        },
        [g, x, S]
      ), s(
        function() {
          return t(R) && A({ inst: R }), g(function() {
            t(R) && A({ inst: R });
          });
        },
        [g]
      ), m(x), x;
    }
    function t(g) {
      var S = g.getSnapshot;
      g = g.value;
      try {
        var x = S();
        return !o(g, x);
      } catch {
        return !0;
      }
    }
    function a(g, S) {
      return S();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var n = We, o = typeof Object.is == "function" ? Object.is : e, u = n.useState, s = n.useEffect, p = n.useLayoutEffect, m = n.useDebugValue, f = !1, c = !1, b = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? a : r;
    ce.useSyncExternalStore = n.useSyncExternalStore !== void 0 ? n.useSyncExternalStore : b, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), ce;
}
process.env.NODE_ENV === "production" ? ve.exports = ur() : ve.exports = sr();
var cr = ve.exports, K = '[cmdk-group=""]', de = '[cmdk-group-items=""]', dr = '[cmdk-group-heading=""]', xe = '[cmdk-item=""]', je = `${xe}:not([aria-disabled="true"])`, ge = "cmdk-item-select", L = "data-value", fr = (e, r, t) => jt(e, r, t), rt = l.createContext(void 0), z = () => l.useContext(rt), nt = l.createContext(void 0), Ce = () => l.useContext(nt), ot = l.createContext(void 0), at = l.forwardRef((e, r) => {
  let t = W(() => {
    var i, v;
    return { search: "", value: (v = (i = e.value) != null ? i : e.defaultValue) != null ? v : "", filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), a = W(() => /* @__PURE__ */ new Set()), n = W(() => /* @__PURE__ */ new Map()), o = W(() => /* @__PURE__ */ new Map()), u = W(() => /* @__PURE__ */ new Set()), s = lt(e), { label: p, children: m, value: f, onValueChange: c, filter: b, shouldFilter: g, loop: S, disablePointerSelection: x = !1, vimBindings: y = !0, ...R } = e, A = k(), Y = k(), Re = k(), M = l.useRef(null), _ = xr();
  V(() => {
    if (f !== void 0) {
      let i = f.trim();
      t.current.value = i, D.emit();
    }
  }, [f]), V(() => {
    _(6, De);
  }, []);
  let D = l.useMemo(() => ({ subscribe: (i) => (u.current.add(i), () => u.current.delete(i)), snapshot: () => t.current, setState: (i, v, E) => {
    var d, w, C;
    if (!Object.is(t.current[i], v)) {
      if (t.current[i] = v, i === "search") re(), ee(), _(1, te);
      else if (i === "value" && (E || _(5, De), ((d = s.current) == null ? void 0 : d.value) !== void 0)) {
        let O = v ?? "";
        (C = (w = s.current).onValueChange) == null || C.call(w, O);
        return;
      }
      D.emit();
    }
  }, emit: () => {
    u.current.forEach((i) => i());
  } }), []), Q = l.useMemo(() => ({ value: (i, v, E) => {
    var d;
    v !== ((d = o.current.get(i)) == null ? void 0 : d.value) && (o.current.set(i, { value: v, keywords: E }), t.current.filtered.items.set(i, _e(v, E)), _(2, () => {
      ee(), D.emit();
    }));
  }, item: (i, v) => (a.current.add(i), v && (n.current.has(v) ? n.current.get(v).add(i) : n.current.set(v, /* @__PURE__ */ new Set([i]))), _(3, () => {
    re(), ee(), t.current.value || te(), D.emit();
  }), () => {
    o.current.delete(i), a.current.delete(i), t.current.filtered.items.delete(i);
    let E = G();
    _(4, () => {
      re(), (E == null ? void 0 : E.getAttribute("id")) === i && te(), D.emit();
    });
  }), group: (i) => (n.current.has(i) || n.current.set(i, /* @__PURE__ */ new Set()), () => {
    o.current.delete(i), n.current.delete(i);
  }), filter: () => s.current.shouldFilter, label: p || e["aria-label"], getDisablePointerSelection: () => s.current.disablePointerSelection, listId: A, inputId: Re, labelId: Y, listInnerRef: M }), []);
  function _e(i, v) {
    var E, d;
    let w = (d = (E = s.current) == null ? void 0 : E.filter) != null ? d : fr;
    return i ? w(i, t.current.search, v) : 0;
  }
  function ee() {
    if (!t.current.search || s.current.shouldFilter === !1) return;
    let i = t.current.filtered.items, v = [];
    t.current.filtered.groups.forEach((d) => {
      let w = n.current.get(d), C = 0;
      w.forEach((O) => {
        let T = i.get(O);
        C = Math.max(T, C);
      }), v.push([d, C]);
    });
    let E = M.current;
    H().sort((d, w) => {
      var C, O;
      let T = d.getAttribute("id"), Z = w.getAttribute("id");
      return ((C = i.get(Z)) != null ? C : 0) - ((O = i.get(T)) != null ? O : 0);
    }).forEach((d) => {
      let w = d.closest(de);
      w ? w.appendChild(d.parentElement === w ? d : d.closest(`${de} > *`)) : E.appendChild(d.parentElement === E ? d : d.closest(`${de} > *`));
    }), v.sort((d, w) => w[1] - d[1]).forEach((d) => {
      var w;
      let C = (w = M.current) == null ? void 0 : w.querySelector(`${K}[${L}="${encodeURIComponent(d[0])}"]`);
      C == null || C.parentElement.appendChild(C);
    });
  }
  function te() {
    let i = H().find((E) => E.getAttribute("aria-disabled") !== "true"), v = i == null ? void 0 : i.getAttribute(L);
    D.setState("value", v || void 0);
  }
  function re() {
    var i, v, E, d;
    if (!t.current.search || s.current.shouldFilter === !1) {
      t.current.filtered.count = a.current.size;
      return;
    }
    t.current.filtered.groups = /* @__PURE__ */ new Set();
    let w = 0;
    for (let C of a.current) {
      let O = (v = (i = o.current.get(C)) == null ? void 0 : i.value) != null ? v : "", T = (d = (E = o.current.get(C)) == null ? void 0 : E.keywords) != null ? d : [], Z = _e(O, T);
      t.current.filtered.items.set(C, Z), Z > 0 && w++;
    }
    for (let [C, O] of n.current) for (let T of O) if (t.current.filtered.items.get(T) > 0) {
      t.current.filtered.groups.add(C);
      break;
    }
    t.current.filtered.count = w;
  }
  function De() {
    var i, v, E;
    let d = G();
    d && (((i = d.parentElement) == null ? void 0 : i.firstChild) === d && ((E = (v = d.closest(K)) == null ? void 0 : v.querySelector(dr)) == null || E.scrollIntoView({ block: "nearest" })), d.scrollIntoView({ block: "nearest" }));
  }
  function G() {
    var i;
    return (i = M.current) == null ? void 0 : i.querySelector(`${xe}[aria-selected="true"]`);
  }
  function H() {
    var i;
    return Array.from(((i = M.current) == null ? void 0 : i.querySelectorAll(je)) || []);
  }
  function ne(i) {
    let v = H()[i];
    v && D.setState("value", v.getAttribute(L));
  }
  function oe(i) {
    var v;
    let E = G(), d = H(), w = d.findIndex((O) => O === E), C = d[w + i];
    (v = s.current) != null && v.loop && (C = w + i < 0 ? d[d.length - 1] : w + i === d.length ? d[0] : d[w + i]), C && D.setState("value", C.getAttribute(L));
  }
  function Oe(i) {
    let v = G(), E = v == null ? void 0 : v.closest(K), d;
    for (; E && !d; ) E = i > 0 ? Sr(E, K) : wr(E, K), d = E == null ? void 0 : E.querySelector(je);
    d ? D.setState("value", d.getAttribute(L)) : oe(i);
  }
  let Ie = () => ne(H().length - 1), Ne = (i) => {
    i.preventDefault(), i.metaKey ? Ie() : i.altKey ? Oe(1) : oe(1);
  }, Ae = (i) => {
    i.preventDefault(), i.metaKey ? ne(0) : i.altKey ? Oe(-1) : oe(-1);
  };
  return l.createElement(P.div, { ref: r, tabIndex: -1, ...R, "cmdk-root": "", onKeyDown: (i) => {
    var v;
    if ((v = R.onKeyDown) == null || v.call(R, i), !i.defaultPrevented) switch (i.key) {
      case "n":
      case "j": {
        y && i.ctrlKey && Ne(i);
        break;
      }
      case "ArrowDown": {
        Ne(i);
        break;
      }
      case "p":
      case "k": {
        y && i.ctrlKey && Ae(i);
        break;
      }
      case "ArrowUp": {
        Ae(i);
        break;
      }
      case "Home": {
        i.preventDefault(), ne(0);
        break;
      }
      case "End": {
        i.preventDefault(), Ie();
        break;
      }
      case "Enter":
        if (!i.nativeEvent.isComposing && i.keyCode !== 229) {
          i.preventDefault();
          let E = G();
          if (E) {
            let d = new Event(ge);
            E.dispatchEvent(d);
          }
        }
    }
  } }, l.createElement("label", { "cmdk-label": "", htmlFor: Q.inputId, id: Q.labelId, style: Rr }, p), X(e, (i) => l.createElement(nt.Provider, { value: D }, l.createElement(rt.Provider, { value: Q }, i))));
}), pr = l.forwardRef((e, r) => {
  var t, a;
  let n = k(), o = l.useRef(null), u = l.useContext(ot), s = z(), p = lt(e), m = (a = (t = p.current) == null ? void 0 : t.forceMount) != null ? a : u == null ? void 0 : u.forceMount;
  V(() => {
    if (!m) return s.item(n, u == null ? void 0 : u.id);
  }, [m]);
  let f = it(n, o, [e.value, e.children, o], e.keywords), c = Ce(), b = F((_) => _.value && _.value === f.current), g = F((_) => m || s.filter() === !1 ? !0 : _.search ? _.filtered.items.get(n) > 0 : !0);
  l.useEffect(() => {
    let _ = o.current;
    if (!(!_ || e.disabled)) return _.addEventListener(ge, S), () => _.removeEventListener(ge, S);
  }, [g, e.onSelect, e.disabled]);
  function S() {
    var _, D;
    x(), (D = (_ = p.current).onSelect) == null || D.call(_, f.current);
  }
  function x() {
    c.setState("value", f.current, !0);
  }
  if (!g) return null;
  let { disabled: y, value: R, onSelect: A, forceMount: Y, keywords: Re, ...M } = e;
  return l.createElement(P.div, { ref: B([o, r]), ...M, id: n, "cmdk-item": "", role: "option", "aria-disabled": !!y, "aria-selected": !!b, "data-disabled": !!y, "data-selected": !!b, onPointerMove: y || s.getDisablePointerSelection() ? void 0 : x, onClick: y ? void 0 : S }, e.children);
}), mr = l.forwardRef((e, r) => {
  let { heading: t, children: a, forceMount: n, ...o } = e, u = k(), s = l.useRef(null), p = l.useRef(null), m = k(), f = z(), c = F((g) => n || f.filter() === !1 ? !0 : g.search ? g.filtered.groups.has(u) : !0);
  V(() => f.group(u), []), it(u, s, [e.value, e.heading, p]);
  let b = l.useMemo(() => ({ id: u, forceMount: n }), [n]);
  return l.createElement(P.div, { ref: B([s, r]), ...o, "cmdk-group": "", role: "presentation", hidden: c ? void 0 : !0 }, t && l.createElement("div", { ref: p, "cmdk-group-heading": "", "aria-hidden": !0, id: m }, t), X(e, (g) => l.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": t ? m : void 0 }, l.createElement(ot.Provider, { value: b }, g))));
}), vr = l.forwardRef((e, r) => {
  let { alwaysRender: t, ...a } = e, n = l.useRef(null), o = F((u) => !u.search);
  return !t && !o ? null : l.createElement(P.div, { ref: B([n, r]), ...a, "cmdk-separator": "", role: "separator" });
}), gr = l.forwardRef((e, r) => {
  let { onValueChange: t, ...a } = e, n = e.value != null, o = Ce(), u = F((f) => f.search), s = F((f) => f.value), p = z(), m = l.useMemo(() => {
    var f;
    let c = (f = p.listInnerRef.current) == null ? void 0 : f.querySelector(`${xe}[${L}="${encodeURIComponent(s)}"]`);
    return c == null ? void 0 : c.getAttribute("id");
  }, []);
  return l.useEffect(() => {
    e.value != null && o.setState("search", e.value);
  }, [e.value]), l.createElement(P.input, { ref: r, ...a, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": p.listId, "aria-labelledby": p.labelId, "aria-activedescendant": m, id: p.inputId, type: "text", value: n ? e.value : u, onChange: (f) => {
    n || o.setState("search", f.target.value), t == null || t(f.target.value);
  } });
}), hr = l.forwardRef((e, r) => {
  let { children: t, label: a = "Suggestions", ...n } = e, o = l.useRef(null), u = l.useRef(null), s = z();
  return l.useEffect(() => {
    if (u.current && o.current) {
      let p = u.current, m = o.current, f, c = new ResizeObserver(() => {
        f = requestAnimationFrame(() => {
          let b = p.offsetHeight;
          m.style.setProperty("--cmdk-list-height", b.toFixed(1) + "px");
        });
      });
      return c.observe(p), () => {
        cancelAnimationFrame(f), c.unobserve(p);
      };
    }
  }, []), l.createElement(P.div, { ref: B([o, r]), ...n, "cmdk-list": "", role: "listbox", "aria-label": a, id: s.listId }, X(e, (p) => l.createElement("div", { ref: B([u, s.listInnerRef]), "cmdk-list-sizer": "" }, p)));
}), br = l.forwardRef((e, r) => {
  let { open: t, onOpenChange: a, overlayClassName: n, contentClassName: o, container: u, ...s } = e;
  return l.createElement(Qt, { open: t, onOpenChange: a }, l.createElement(er, { container: u }, l.createElement(tr, { "cmdk-overlay": "", className: n }), l.createElement(rr, { "aria-label": e.label, "cmdk-dialog": "", className: o }, l.createElement(at, { ref: r, ...s }))));
}), yr = l.forwardRef((e, r) => F((t) => t.filtered.count === 0) ? l.createElement(P.div, { ref: r, ...e, "cmdk-empty": "", role: "presentation" }) : null), Er = l.forwardRef((e, r) => {
  let { progress: t, children: a, label: n = "Loading...", ...o } = e;
  return l.createElement(P.div, { ref: r, ...o, "cmdk-loading": "", role: "progressbar", "aria-valuenow": t, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": n }, X(e, (u) => l.createElement("div", { "aria-hidden": !0 }, u)));
}), j = Object.assign(at, { List: hr, Item: pr, Input: gr, Group: mr, Separator: vr, Dialog: br, Empty: yr, Loading: Er });
function Sr(e, r) {
  let t = e.nextElementSibling;
  for (; t; ) {
    if (t.matches(r)) return t;
    t = t.nextElementSibling;
  }
}
function wr(e, r) {
  let t = e.previousElementSibling;
  for (; t; ) {
    if (t.matches(r)) return t;
    t = t.previousElementSibling;
  }
}
function lt(e) {
  let r = l.useRef(e);
  return V(() => {
    r.current = e;
  }), r;
}
var V = typeof window > "u" ? l.useEffect : l.useLayoutEffect;
function W(e) {
  let r = l.useRef();
  return r.current === void 0 && (r.current = e()), r;
}
function B(e) {
  return (r) => {
    e.forEach((t) => {
      typeof t == "function" ? t(r) : t != null && (t.current = r);
    });
  };
}
function F(e) {
  let r = Ce(), t = () => e(r.snapshot());
  return cr.useSyncExternalStore(r.subscribe, t, t);
}
function it(e, r, t, a = []) {
  let n = l.useRef(), o = z();
  return V(() => {
    var u;
    let s = (() => {
      var m;
      for (let f of t) {
        if (typeof f == "string") return f.trim();
        if (typeof f == "object" && "current" in f) return f.current ? (m = f.current.textContent) == null ? void 0 : m.trim() : n.current;
      }
    })(), p = a.map((m) => m.trim());
    o.value(e, s, p), (u = r.current) == null || u.setAttribute(L, s), n.current = s;
  }), n;
}
var xr = () => {
  let [e, r] = l.useState(), t = W(() => /* @__PURE__ */ new Map());
  return V(() => {
    t.current.forEach((a) => a()), t.current = /* @__PURE__ */ new Map();
  }, [e]), (a, n) => {
    t.current.set(a, n), r({});
  };
};
function Cr(e) {
  let r = e.type;
  return typeof r == "function" ? r(e.props) : "render" in r ? r.render(e.props) : e;
}
function X({ asChild: e, children: r }, t) {
  return e && l.isValidElement(r) ? l.cloneElement(Cr(r), { ref: r.ref }, t(r.props.children)) : t(r);
}
var Rr = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
const _r = ut(
  ({
    className: e,
    disabled: r,
    hasError: t,
    defaultCountry: a = "US",
    onChange: n,
    value: o,
    ...u
  }, s) => {
    const [p, m] = ke(
      a
    ), [f, c] = ke(!1), b = st(null);
    ct(s, () => b.current, []), dt(() => {
      if (o) {
        const { countryCode: y, phoneNumber: R } = le(o);
        y && m(y), n == null || n(R ?? o);
      }
    }, [o, n]);
    const g = Me.find(
      (y) => y.iso2 === p
    );
    function S(y) {
      const { formattedValue: R } = le(y, p);
      return R;
    }
    function x(y) {
      if (b.current) {
        const { formattedValue: R, countryCode: A, phoneNumber: Y } = le(
          y.currentTarget.value,
          p
        );
        A && m(A), b.current.value = R, n == null || n(Y ?? Nt(R));
      }
    }
    return /* @__PURE__ */ N(
      "div",
      {
        className: ae(
          // Base
          "h-s-6 pr-sp-3 flex items-center rounded-md border text-(--color-input-content) transition-colors",
          // Border colors
          "border-(--color-input-stroke) focus-within:border-(--color-input-stroke-active) [&:hover:not(:focus-within)]:border-(--color-input-stroke-hover)",
          // Ring colors
          "focus-within:ring-3 focus-within:ring-(--color-input-highlight-active) ",
          // Disabled
          "has-[:disabled]:border-(--color-input-stroke-disabled) has-[:disabled]:text-(--color-input-content-disabled) [&:hover]:has-[:disabled]:border-(--color-input-stroke-disabled)",
          // Error
          {
            "border-(--color-input-stroke-danger) focus-within:border-(--color-input-stroke-danger) [&:hover:not(:focus-within)]:border-(--color-input-stroke-danger) focus-within:ring-3 focus-within:ring-(--color-input-highlight-danger)": t
          },
          e
        ),
        children: [
          /* @__PURE__ */ N(Rt, { open: f, onOpenChange: c, children: [
            /* @__PURE__ */ h(_t, { asChild: !0, children: /* @__PURE__ */ N(
              "button",
              {
                className: ae(
                  "gap-sp-2 rounded-xs pl-sp-3 outline-hidden flex h-full items-center",
                  Ct
                ),
                disabled: r,
                children: [
                  g ? /* @__PURE__ */ h("span", { className: "text-[1.25rem]", children: g.emoji }) : /* @__PURE__ */ h("span", { className: "size-s-3" }),
                  /* @__PURE__ */ h(
                    Pe,
                    {
                      name: "chevron-down",
                      className: ae("transition-transform", {
                        "rotate-180": f
                      })
                    }
                  )
                ]
              }
            ) }),
            /* @__PURE__ */ h(Dt, { align: "start", className: "shadow-xl", children: /* @__PURE__ */ N(j, { className: "flex size-full flex-col overflow-hidden rounded-md", children: [
              /* @__PURE__ */ N("div", { className: "gap-sp-2 px-sp-5 pt-sp-4 flex items-center pb-[calc(var(--fui-subline)*3+var(--fui-subline)*0.5)]", children: [
                /* @__PURE__ */ h(
                  Pe,
                  {
                    name: "search",
                    className: "shrink-0 text-(--color-input-placeholder)"
                  }
                ),
                /* @__PURE__ */ h(
                  j.Input,
                  {
                    className: "outline-hidden flex w-full bg-transparent placeholder:text-(--color-input-placeholder) disabled:cursor-not-allowed disabled:text-(--color-input-content-disabled)",
                    placeholder: "Search country..."
                  }
                )
              ] }),
              /* @__PURE__ */ h("span", { className: "-mx-sp-2 border-b border-(--color-input-stroke)" }),
              /* @__PURE__ */ N(j.List, { className: "px-sp-2 pb-sp-2 max-h-[300px] overflow-y-auto overflow-x-hidden", children: [
                /* @__PURE__ */ h(j.Empty, { className: "px-sp-4 pb-sp-3 pt-sp-4", children: "No countries found" }),
                /* @__PURE__ */ h(j.Group, { className: "[&>[cmdk-group-items]]:gap-sp-0_5 [&>[cmdk-group-items]]:flex [&>[cmdk-group-items]]:flex-col [&>[cmdk-group-items]]:pt-[calc(var(--fui-subline)+var(--fui-subline)*0.25)]", children: Me.map((y) => /* @__PURE__ */ N(
                  j.Item,
                  {
                    className: "gap-sp-2 rounded-xs px-sp-3 py-sp-2 text-body1 text-(--color-dropdown-item-content) outline-hidden data-[disabled=true]:bg-(--color-dropdown-item-bg-disabled) data-[selected=true]:bg-(--color-dropdown-item-bg-active) data-[disabled=true]:text-(--color-dropdown-item-content-disabled) flex w-full items-center bg-transparent data-[disabled=true]:pointer-events-none",
                    onSelect: () => {
                      b.current && (b.current.value = `+${y.phone_code}`, b.current.focus()), m(y.iso2), c(!1);
                    },
                    children: [
                      /* @__PURE__ */ h("div", { className: "size-s-3 flex items-center justify-center text-[1.25rem]", children: y.emoji }),
                      /* @__PURE__ */ N("span", { children: [
                        y.name,
                        " (+",
                        y.phone_code,
                        ")"
                      ] })
                    ]
                  },
                  y.iso2
                )) })
              ] })
            ] }) })
          ] }),
          /* @__PURE__ */ h("div", { className: "ml-sp-2 h-s-3 bg-(--color-input-stroke) w-[1px]" }),
          /* @__PURE__ */ h(
            "input",
            {
              ref: b,
              type: "tel",
              autoComplete: "tel",
              className: "pl-sp-2 text-body1 outline-hidden size-full appearance-none bg-transparent",
              onChange: x,
              disabled: r,
              value: o !== void 0 ? S(o) : void 0,
              ...u
            }
          )
        ]
      }
    );
  }
);
_r.displayName = "PhoneInput";
export {
  _r as PhoneInput
};
